import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import * as Api from "@/api";
import Search from "@/design/components/Search";
import useSearch from "@/utils/hooks/useSearch";
import Valkyrie, { viPerson, viXmark } from "@sippy-platform/valkyrie";

import { Box, Button, Drawer, IconButton, List, ListItem, ListItemText, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";

import AddMemberItem from "./AddMemberItem";

function QueueMembers({ queue, queueDispatch }) {
  const queueMembersStore = useSelector((state) => state.domain.queueMembers);

  // Fetch data from API
  useEffect(() => {
    Promise.resolve(Api.getPossibleQueueMembers());
  }, []);

  // Drawer
  const [drawer, setDrawer] = useState(null);
  const [searchValue, setSearchValue] = useState("");

  const searchResults = useSearch(queueMembersStore.list, searchValue, ["attributes.name", "attributes.exten"]);

  const closeDrawer = useCallback(() => {
    setDrawer(undefined);
    setSearchValue("");
  }, []);

  return (
    <>
      <Button onClick={() => setDrawer(true)} variant="contained" startIcon={<Valkyrie icon={viPerson} />}>
        Manage
      </Button>
      <Drawer
        open={!!drawer}
        onClose={() => closeDrawer()}
        anchor="right"
        slotProps={{
          paper: {
            sx: (theme) => ({ maxWidth: 320, width: 1, p: 1.5, display: "flex", gap: 1, ...theme.scrollbar }),
            elevation: 4,
          },
        }}
      >
        <Stack
          direction="row"
          sx={{
            gap: 1,
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h5">Manage members</Typography>
          <IconButton onClick={() => closeDrawer()} color="inherit">
            <Valkyrie icon={viXmark} />
          </IconButton>
        </Stack>
        <Box sx={{ position: "sticky", top: 0, zIndex: 1000 }}>
          <Search blur value={searchValue} onChange={setSearchValue} />
        </Box>
        <List>
          {searchResults.length >= 1 ? (
            searchResults.map((member) => (
              <AddMemberItem key={member.id} member={member} queueDispatch={queueDispatch} queue={queue} />
            ))
          ) : (
            <ListItem>
              <ListItemText primary="There are no queue members available..." />
            </ListItem>
          )}
        </List>
      </Drawer>
    </>
  );
}

QueueMembers.propTypes = {
  queue: PropTypes.object,
  queueDispatch: PropTypes.func,
};

export default QueueMembers;
